import React, { useEffect, useState } from 'react';
import api from '../../api/api';
import { toastError } from '../../utils/toasts';
import { Card, Button } from '../../components/ui';

export default function StockSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [defaultUnit, setDefaultUnit] = useState('pcs');
  const [lowStockAlert, setLowStockAlert] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/stock/settings');
        if (res.data.ok) {
          setSettings(res.data.settings);
          setDefaultUnit(res.data.settings.defaultUnit || 'pcs');
          setLowStockAlert(res.data.settings.lowStockAlert !== false);
        }
      } catch (err) {
        console.error('Erreur chargement paramètres stock:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await api.put('/stock/settings', { defaultUnit, lowStockAlert });
      if (res.data.ok) setSettings(res.data.settings);
    } catch (err) {
      console.error('Erreur sauvegarde paramètres:', err);
      toastError('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="text-gray-500 p-6">Chargement...</p>;

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Paramètres du Stock</h1>

        <Card className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Unité par défaut</label>
            <select
              value={defaultUnit}
              onChange={(e) => setDefaultUnit(e.target.value)}
              className="border rounded px-3 py-2 text-sm w-full max-w-xs"
            >
              <option value="pcs">Pièce</option>
              <option value="kg">Kilogramme</option>
              <option value="g">Gramme</option>
              <option value="l">Litre</option>
              <option value="ml">Millilitre</option>
              <option value="m">Mètre</option>
              <option value="m2">Mètre carré</option>
              <option value="box">Boîte</option>
              <option value="pack">Pack</option>
            </select>
          </div>

          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              id="lowStockAlert"
              checked={lowStockAlert}
              onChange={(e) => setLowStockAlert(e.target.checked)}
              className="h-4 w-4 rounded border-gray-300"
            />
            <label htmlFor="lowStockAlert" className="text-sm font-medium text-gray-700">
              Activer l'alerte de stock bas
            </label>
          </div>

          <div className="pt-4">
            <Button variant="primary" onClick={handleSave} disabled={saving}>
              {saving ? 'Sauvegarde...' : 'Enregistrer'}
            </Button>
          </div>

          {settings && (
            <div className="pt-4 border-t text-xs text-gray-500">
              <p>Statut: {settings.enabled ? 'Activé' : 'Désactivé'}</p>
              <p>Dernière mise à jour: {new Date(settings.updatedAt).toLocaleString('fr-TN')}</p>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
